export default "__VITE_ASSET__DYhgVeTA__"